import React from "react";
import { connect } from "react-redux";
import $ from "jquery";
import {
  endCall,
  sendMessage as sendTxt,
  muteAudio,
  muteVideo,
  muteRemoteAudio,
  stopRemoteAudio,
  stopVideo,
  stopAudio,
} from "../../actions/sipActions";
import { unBindLocalStream } from "../../actions/configActions";
import ActionTypes from "../../actions/actionTypes";
import DialerView from "../../containers/DialerView";
import RealTimeText from "../../components/RealTimeText";
import AudioVideo from "../../components/AudioVideo";
import InCallButtonBar from "../../components/InCallButtonBar";
import Fullscreen from "react-full-screen";

import "./InMainCall.css";
import UnsupportedBrowser from "../../containers/UnsupportedBrowser";

class InMainCall extends React.Component {
  inCallAlready = false;

  beforeUnload(e) {
    e.preventDefault();
    e.returnValue = "";
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.beforeUnload, false);
    window.addEventListener("resize", this.adjustVideoSize.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.beforeUnload, false);
    window.removeEventListener("resize", this.adjustVideoSize.bind(this));
    this.props.unBindLocalStream();
  }

  adjustVideoSize() {
    if (this.props.videoavailable) {
      if (this.props.videoVisible) {
        setTimeout(() => {
          $("#videoContainer").width($("#remote-video").width() + "px");
          $("#remote-video-container").width($("#remote-video").width() + "px");
          if (this.props && this.props.browser.name === "ie") {
            $(".inCallTextContainer").width($(window).width() - $("#videoContainer").width() + "px");
          }
        }, 50);
      } else {
        $("#videoContainer").width("0px");
        $("#remote-video-container").width("0px");
        if (this.props && this.props.browser.name === "ie") {
          $(".inCallTextContainer").width($(window).width() + "px");
        }
      }
    }
  }

  render() {
    if (this.inCallAlready === false) {
      this.inCallAlready = true;
    }
    this.adjustVideoSize();
    $("#remote-video").resize(() => {
      this.adjustVideoSize();
    });

    var smallScreenMode = window.innerWidth < 992 ? true : false;
    var videoIsVisible = this.props.videoavailable && (!smallScreenMode || this.props.videoMode);
    var textIsVisible = this.props.textavailable && this.props.textVisible && (!smallScreenMode || !videoIsVisible);
    if (this.props.video && !this.props.videoavailable) {
      this.props.stopVideo();
    }
    if (this.props.audio && !this.props.audioavailable) {
      this.props.stopAudio();
      this.props.stopRemoteAudio();
    }

    //
    // Height will be 100vh except for iOS devices where the height must be adjusted for the view to
    // look good. Otherwise the view will scroll when the soft keyboard is shown and hide the footer
    // or header buttons.
    //
    return (
      <Fullscreen enabled={this.props.fullscreenEnabled} onChange={this.props.handleFullscreenChange}>
        <div className="callFullscreen">
          <div
            className={
              "box callContainer " +
              (this.props.browser.os === "iOS" ? "height-IOS" : "height-100-procent") +
              (!this.props.videoVisible && !this.props.textVisible ? "" : "")
            }
          >
            {!this.props.videoVisible && !this.props.textVisible && (
              <p className="margin-auto">{this.props.l10n("call.videoTextDisabled")}</p>
            )}

            <div class="incall-alert">
              <UnsupportedBrowser />
            </div>

            <main
              role={"main"}
              className={
                "content callViewContainer" + (this.props.videoVisible || this.props.textVisible ? "" : "display-none")
              }
            >
              <h1 style={{ display: "none" }}>{this.props.l10n("aria.in-call")}</h1>
              <div
                id={"videoContainer"}
                ref={n => (this.node1 = n)}
                className={"inCallVideoContainer" + (videoIsVisible ? "" : " display-none")}
              >
                <AudioVideo
                  isVisible={this.props.videoVisible}
                  isVideoAvailable={this.props.videoavailable}
                  direction="remote"
                  kioskmode={false}
                  textIsVisible={textIsVisible}
                />
                <AudioVideo
                  isVisible={this.props.selfViewVisible}
                  isVideoAvailable={this.props.videoavailable}
                  direction="local"
                  kioskmode={false}
                />
              </div>
              {this.props.text_enabled && (
                <div
                  ref={n => (this.node2 = n)}
                  className={"padding-zero inCallTextContainer" + (textIsVisible ? "" : " display-none")}
                >
                  <RealTimeText
                    isVisible={this.props.textVisible}
                    layout={this.props.textLayout}
                    text={this.props.text}
                    colors={this.props.colors}
                    font={this.props.font}
                    sendTxt={this.props.sendTxt}
                    kioskmode={false}
                    placeholderCombined={this.props.l10n("call.writeHere")}
                    placeholderOutgoing={this.props.l10n("call.writeHere")}
                    placeholderIncoming={this.props.l10n("call.receiveHere")}
                    titleCombined={this.props.l10n("settings.one")}
                    titleOutgoing={this.props.l10n("call.outgoingtext")}
                    titleIncoming={this.props.l10n("call.incomingtext")}
                  />
                </div>
              )}
            </main>
            <DialerView />
            <InCallButtonBar
              l10n={this.props.l10n}
              isAudioAvailable={this.props.audioavailable}
              isVideoAvailable={this.props.videoavailable}
              isTextAvailable={this.props.textavailable}
              isVideoVisible={this.props.videoVisible}
              isTextEnabled={this.props.text_enabled}
              isSoundOn={this.props.soundOn}
              isTextVisible={this.props.textVisible}
              isDialerVisible={this.props.dialerVisible}
              isSelfViewVisible={this.props.selfViewVisible}
              videoMode={this.props.videoMode}
              unreadText={this.props.unreadText}
              audio={this.props.audio}
              video={this.props.video}
              hangup={() => this.props.hangup()}
              muteAudio={() => this.props.muteAudio()}
              muteVideo={() => this.props.muteVideo()}
              muteRemoteAudio={() => this.props.muteRemoteAudio()}
              hideVideo={() => this.props.hideVideo()}
              hideText={() => this.props.hideText()}
              hideDialer={() => this.props.hideDialer()}
              hideSelfview={() => this.props.hideSelfview()}
              kioskmode={false}
              smallScreenMode={smallScreenMode}
              show={this.props.show}
              showMore={() => this.props.showMore()}
              toggleVideoMode={() => this.props.toggleVideoMode()}
              isFullscreenAvailable={this.props.fullscreenAvailable}
              isFullscreenEnabled={this.props.fullscreenEnabled}
              toggleFullscreen={() => this.props.toggleFullscreen()}
            />
          </div>
        </div>
      </Fullscreen>
    );
  }
}

const mapStateToProps = state => {
  return {
    text: {
      in: state.call.text_in,
      out: state.call.text_out,
      combined: state.call.text_combined,
    },
    unreadText: state.call.text_unread,
    font: {
      size: state.setting.user.WEB_TEXT_SIZE,
      family: state.setting.user.WEB_FONT,
    },
    colors: {
      background: state.setting.user.WEB_ONEBOX_TEXT_BACKGROUND_COLOR,
      foreground: state.setting.user.WEB_ONEBOX_TEXT_COLOR,
      in: {
        foreground: state.setting.user.WEB_TEXT_IN_COLOR,
        background: state.setting.user.WEB_TEXTAREA_IN_BACKGROUND,
      },
      out: {
        foreground: state.setting.user.WEB_TEXT_OUT_COLOR,
        background: state.setting.user.WEB_TEXTAREA_OUT_BACKGROUND,
      },
    },
    textLayout: state.setting.user.WEB_CHAT_LAYOUT,
    l10n: state.config.text,
    audioavailable: state.call.audioavailable && state.sip.negotiated.audio,
    videoavailable: state.call.videoavailable && state.sip.negotiated.video,
    textavailable: state.call.textavailable && state.sip.negotiated.text,
    fullscreenAvailable: document.fullscreenEnabled ? state.config.mode.fullscreen : false,
    fullscreenEnabled: state.call.fullscreenEnabled,
    audio: state.call.audio,
    video: state.call.video,
    videoVisible: state.call.videoVisible,
    textVisible: state.call.textVisible,
    text_enabled: state.config.mode.safetext,
    videoMode: state.call.videoMode,
    soundOn: state.call.soundOn,
    dialerVisible: state.call.dialerVisible,
    selfViewVisible: state.call.selfViewVisible,
    show: state.call.showMore,
    browser: state.config.browser,
    contrast: state.accessibility.isHighContrast,
    ringsignals: state.config.ringsignals,
    signal: state.setting.user.WEB_RINGTONE,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hangup: () => {
      return dispatch(endCall());
    },
    sendTxt: str => {
      return dispatch(sendTxt(str));
    },
    muteAudio: () => {
      return dispatch(muteAudio());
    },
    muteVideo: () => {
      return dispatch(muteVideo());
    },
    stopAudio: () => {
      return dispatch(stopAudio());
    },
    stopVideo: () => {
      return dispatch(stopVideo());
    },
    muteRemoteAudio: () => {
      return dispatch(muteRemoteAudio());
    },
    stopRemoteAudio: () => {
      return dispatch(stopRemoteAudio());
    },
    hideVideo: () => {
      return dispatch({
        type: ActionTypes.CALL_HIDE_VIDEO,
      });
    },
    hideText: () => {
      return dispatch({
        type: ActionTypes.CALL_HIDE_TEXT,
      });
    },
    hideDialer: () => {
      return dispatch({
        type: ActionTypes.CALL_HIDE_DIALER,
      });
    },
    hideSelfview: () => {
      return dispatch({
        type: ActionTypes.CALL_HIDE_SELFVIEW,
      });
    },
    showMore: () => {
      return dispatch({
        type: ActionTypes.CALL_SHOW_MORE,
      });
    },
    toggleVideoMode: () => {
      return dispatch({
        type: ActionTypes.CALL_TOGGLE_VIDEO_MODE,
      });
    },
    toggleFullscreen: () => {
      return dispatch({
        type: ActionTypes.CALL_TOGGLE_FULLSCREEN,
      });
    },
    handleFullscreenChange: isFullscreen => {
      return dispatch({
        type: ActionTypes.CALL_TOGGLE_FULLSCREEN,
        payload: isFullscreen,
      });
    },
    unBindLocalStream: () => {
      return dispatch(unBindLocalStream());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InMainCall);



// WEBPACK FOOTER //
// ./src/kiosk/callStates/InMainCall.jsx